const UAE_PASS_FALLBACK_IMAGE_EN = require('@assets/images/uae-pass-login-button.png');
const UAE_PASS_FALLBACK_IMAGE_AR = require('@assets/images/uae-pass-login-button-ar.png');

/** Official artwork ratios: English 506×100, Arabic 608×100. */
const UAE_PASS_FALLBACK_ASPECT_EN = 506 / 100;
const UAE_PASS_FALLBACK_ASPECT_AR = 608 / 100;

export function uaePassLoginButtonFallback(language: string) {
    return language === 'ar' ? UAE_PASS_FALLBACK_IMAGE_AR : UAE_PASS_FALLBACK_IMAGE_EN;
}

export function uaePassLoginButtonFallbackAspect(language: string): number {
    return language === 'ar' ? UAE_PASS_FALLBACK_ASPECT_AR : UAE_PASS_FALLBACK_ASPECT_EN;
}
